import {ValueObject} from '@s-ui/domain'

import {FilterIdSearchValueObject} from './FilterIdSearchValueObject.js'

export class FilterContractIdSearchValueObject extends ValueObject {
  #contractId

  constructor({contractId}) {
    super()
    this.#contractId = contractId
  }

  static create({contractId}) {
    return new FilterContractIdSearchValueObject({contractId: FilterIdSearchValueObject.create(contractId)})
  }

  static createWithDefaultValue({config, contractId}) {
    const {DEFAULT_CONTRACT_ID_SEARCH} = config.get('searchFilters')

    return new FilterContractIdSearchValueObject({
      contractId: FilterIdSearchValueObject.create({id: contractId ?? DEFAULT_CONTRACT_ID_SEARCH})
    })
  }

  get isEmpty() {
    return this.#contractId.isEmpty
  }

  get value() {
    return this.#contractId.value
  }

  toJSON() {
    return {
      contractId: this.#contractId.toJSON()
    }
  }
}
